import _extends from "@babel/runtime/helpers/extends";
/**
 * @jsxRuntime classic
 * @jsx jsx
 */
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { jsx } from '@emotion/react';
import LozengeActionItem from '../lozenge-action-item';
import { dropdownItemGroupStyles } from '../styled';
import { DropdownItemGroup } from '@atlaskit/dropdown-menu';
var LozengeActionItemsGroup = function LozengeActionItemsGroup(_ref) {
  var items = _ref.items,
    testId = _ref.testId,
    onClick = _ref.onClick;
  return (
    // eslint-disable-next-line @atlaskit/design-system/prefer-primitives, @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    jsx("span", {
      css: dropdownItemGroupStyles,
      "data-testid": "".concat(testId, "-item-group")
    }, jsx(DropdownItemGroup, null, items.map(function (item, idx) {
      return jsx(LozengeActionItem, _extends({}, item, {
        key: idx,
        onClick: onClick,
        testId: "".concat(testId, "-item-").concat(idx)
      }));
    })))
  );
};
export default LozengeActionItemsGroup;